import Vue from 'vue'

import EventBus from "vue-plugin-event-bus"

Vue.use(EventBus);

import Axios from "vue-plugin-axios-module"

Vue.use(Axios);

import VueFire from 'vuefire'

Vue.use(VueFire);

import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import Vuetify from 'vuetify'

Vue.use(Vuetify, {
    iconfont: 'mdi'
});

import SuiVue from 'semantic-ui-vue';
import 'semantic-ui-css/semantic.min.css'

Vue.use(SuiVue);